import { useState } from "react";
import '../../styles/ui/modal.scss'
import Button from "./Button";


const Modal = ({children, component}) => {
    
    const [modal, setModal] = useState(false)
    const changeModal = (value) => {
        setModal(value)
    }

    return (
        <div className="modal-container">
            {
                modal && 
                <div className="modal-wrapper">
                    <div className="component-wrapper">
                    {
                        component
                    }
                    </div>
                    <Button type="solid" color="blue" text="Close"  onClick={()=>{changeModal(false)}}/>
                </div>
            }
            <div className="modal-button" onClick={()=>changeModal(true)}>
                { children }
            </div>
        </div>
    )
}

export default Modal;